import { render, staticRenderFns } from "./SetupTOTP.vue?vue&type=template&id=15adee44"
import script from "./SetupTOTP.vue?vue&type=script&lang=js"
export * from "./SetupTOTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports